import { defineComponent } from 'vue';
import UnauthorizedLayout from '@/app/ui/UnauthorizedLayout.vue';
export default defineComponent({
  name: 'LayoutLanding',
  components: {
    UnauthorizedLayout: UnauthorizedLayout
  },
  setup: function setup() {
    return {};
  }
});